/* eslint-disable react/no-danger */
import { Modal } from '@orobix/orobix-fe-components'
import i18n from 'i18next'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import WhatsNewEN from '../../assets/WHATSNEW.md'
import WhatsNewIT from '../../assets/WHATSNEW_IT.md'
import { getEnvs } from '../../utils/env'

export interface WhatsNewModalProps {
  onCloseRequest: () => void
}

export const WhatsNewModal = ({ onCloseRequest }: WhatsNewModalProps) => {
  const { t } = useTranslation()
  const [fileContent, setFileContent] = useState('')
  const feVersion = process.env.REACT_APP_GIT_VERSION
  const { backendAppVersion } = getEnvs()

  useEffect(() => {
    const source = i18n.language.startsWith('it') ? WhatsNewIT : WhatsNewEN
    fetch(source)
      .then((res) => res.text())
      .then((text) => setFileContent(text))
  }, [])

  return (
    <Modal
      size="lg"
      onCloseRequest={onCloseRequest}
      title={`${t(
        "What's new"
      )} [Frontend: ${feVersion} - Backend: ${backendAppVersion}]`}
    >
      <div dangerouslySetInnerHTML={{ __html: fileContent }} />
    </Modal>
  )
}

export default WhatsNewModal
